import React, { useEffect } from "react";
import { Calendar, MapPin, Tag } from "lucide-react";
import { useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useLanguage } from "../context/LanguageContext";
import { Card } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import {
  fetchActivityBySlug,
  clearSelectedActivity,
} from "../features/activity/activitySlice";

const ActivityDetail = () => {
  const { t } = useLanguage();
  const { slug } = useParams();
  const dispatch = useDispatch();

  // Ambil state dengan aman
  const activitiesState = useSelector((state) => state.activities || {});
 
  const { selectedActivity, loading, pagination,error } = useSelector(
    (state) => state.activity
  );
  console.log("selectedActivity",selectedActivity);
  
  useEffect(() => {
    if (slug) dispatch(fetchActivityBySlug(slug));
    return () => dispatch(clearSelectedActivity());
  }, [dispatch, slug]);

  const categoryColors = {
    Environmental: "rgba(13, 121, 22, 0.1)",
    Lingkungan: "rgba(13, 121, 22, 0.1)",
    Important: "rgba(255, 87, 34, 0.1)",
    Info: "rgba(33, 150, 243, 0.1)",
    Success: "rgba(76, 175, 80, 0.1)",
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-green-700 text-lg font-medium">Loading selectedActivity?...</p>
      </div>
    );
  }

  if (error || !selectedActivity) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center text-center p-4">
        <p className="text-gray-600 text-lg mb-4">
          {error ? "Failed to load selectedActivity?." : "Activity not found."}
        </p>
        <Link
          to="/activities"
          className="px-5 py-2 border border-green-700 text-green-700 rounded-full font-medium hover:bg-green-700 hover:text-white transition-all"
        >
          ← Back to Activities
        </Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section
        className="text-center py-20 px-4"
        style={{
          background:
            "radial-gradient(at 50% 30%, hsla(108,100%,50%,0.2) 0px, transparent 50%)",
        }}
      >
        <div className="max-w-3xl mx-auto">
          <h1 className="font-bold text-4xl md:text-5xl text-green-900">
            {selectedActivity?.title}
          </h1>
          <p className="text-gray-600 mt-3 text-sm md:text-base">
            {selectedActivity?.location} | {selectedActivity?.start_date} - {selectedActivity?.end_date}
          </p>
        </div>
      </section>

      {/* Detail Section */}
      <section className="max-w-4xl mx-auto px-4 py-10">
        <Card className="overflow-hidden border border-gray-200 rounded-2xl shadow-sm">
          {/* Gambar Utama */}
          {selectedActivity?.image && (
            <img
              src={selectedActivity?.image}
              alt={selectedActivity?.title}
              className="w-full h-96 object-cover"
            />
          )}

          {/* Konten */}
          <div className="p-6 md:p-8">
            {/* Label */}
            {selectedActivity?.label && (
              <Badge
                style={{
                  background:
                    categoryColors[selectedActivity?.label] || "rgba(0,0,0,0.05)",
                  color: "rgb(0,55,32)",
                  padding: "0.4rem 1rem",
                  borderRadius: "9999px",
                  fontSize: "0.8rem",
                  fontWeight: 500,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "0.25rem",
                }}
              >
                <Tag size={14} /> {selectedActivity?.label}
              </Badge>
            )}

            {/* Informasi tanggal & lokasi */}
            <div className="mt-4 text-gray-600 text-sm leading-relaxed space-y-1">
              {selectedActivity?.start_date && (
                <div>
                  <Calendar size={14} className="inline mr-1" />
                  {selectedActivity?.start_date} - {selectedActivity?.end_date}
                </div>
              )}
              {selectedActivity?.location && (
                <div>
                  <MapPin size={14} className="inline mr-1" />{" "}
                  {selectedActivity?.location}
                </div>
              )}
            </div>

            {/* Deskripsi singkat */}
            {selectedActivity?.description && (
              <p className="mt-6 text-gray-800 leading-relaxed text-base md:text-lg">
                {selectedActivity?.description}
              </p>
            )}

            {/* Konten HTML penuh */}
            {selectedActivity?.content && (
              <div
                className="mt-6 prose prose-green max-w-none"
                dangerouslySetInnerHTML={{ __html: selectedActivity?.content }}
              />
            )}

            {/* Tombol kembali */}
            <div className="mt-10">
              <Link
                to="/activities"
                className="inline-block px-5 py-2 border border-green-700 text-green-700 rounded-full font-medium hover:bg-green-700 hover:text-white transition-all"
              >
                ←{" "}
                {t.nav?.home === "Home"
                  ? "Back to Activities"
                  : "Kembali ke Kegiatan"}
              </Link>
            </div>
          </div>
        </Card>
      </section>
    </div>
  );
};

export default ActivityDetail;
